import SvgIcon, {
  SvgIconProps,
} from '@mui/material/SvgIcon';
import React from 'react';

export default function SortDescIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.247736 1.48938L2.41193 3.74524C2.73782 4.08492 3.26424 4.08492 3.59013 3.74524L5.75432 1.48938C6.28075 0.940664 5.90473 0 5.16105 0H0.832654C0.088972 0 -0.278691 0.940664 0.247736 1.48938Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
}
